import { render } from "./TakeAttendance.vue?vue&type=template&id=0735b16b&scoped=true"
import script from "./TakeAttendance.vue?vue&type=script&lang=js"
export * from "./TakeAttendance.vue?vue&type=script&lang=js"

import "./TakeAttendance.vue?vue&type=style&index=0&id=0735b16b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0735b16b"]])

export default __exports__